import MyTickets from './list'
import MyTicketDetail from './detail'

export {
  MyTickets,
  MyTicketDetail
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tickets/index.js